import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress, Alert } from '@mui/material';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// 1. الأكشن الخاص بتسجيل الدخول
import { loginUser } from '../services/authServices/loginService';
// 2. الأكشن الخاص بجلب المعرف الطويل عبر NFC 
import { fetchTeacherDataByNfc } from '../services/dailyPlanSlice'; 
// 3. الأكشن الخاص بجلب تفاصيل الخطة بالمعرف الطويل
import { fetchDailyPlan } from '../services/authServices/getSetionService';

const ManualLoginForm = ({ setIsAuthenticated }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({ identifier: '', password: '' });
  const [localLoading, setLocalLoading] = useState(false);
  const [localError, setLocalError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.identifier || !credentials.password) {
      setLocalError("يرجى إدخال المعرف وكلمة المرور بشكل صحيح.");
      return;
    }

    setLocalLoading(true);
    setLocalError(null);

    try {
      // 1️⃣ إرسال طلب تسجيل الدخول
      const loginPayload = await dispatch(loginUser({
        userId: credentials.identifier,
        password: credentials.password
      })).unwrap();

      const nfcId = loginPayload?.user?.nfcId;
      if (!nfcId) {
        throw new Error("عذراً، لا يوجد معرف (NFC) مرتبط بهذا الحساب.");
      }

      // 2️⃣ استخدام الدالة الجاهزة لجلب بيانات المعلم (POST) لاستخراج المعرف الطويل
      const teacherPayload = await dispatch(fetchTeacherDataByNfc(nfcId)).unwrap();
      
      const dailyPlanId = teacherPayload?.data?.dailyPlan;
      if (!dailyPlanId) {
        throw new Error("لم يتم العثور على خطة يومية (dailyPlan) لهذا المعلم في الوقت الحالي.");
      }

      // 3️⃣ استخدام الدالة الجاهزة لجلب تفاصيل الخطة (GET) باستخدام المعرف الطويل
      await dispatch(fetchDailyPlan(dailyPlanId)).unwrap();

      // 4️⃣ حفظ بيانات الدخول في الذاكرة المحلية
      localStorage.setItem('isLoggedIn', 'true');
      
      // ✅ التعديل الجديد: حفظ المعرف الطويل (sessionHash) لكي لا تُفقد البيانات عند تحديث الصفحة
      localStorage.setItem('sessionHash', dailyPlanId); 
      
      // 5️⃣ تحديث حالة الـ Router ثم التوجيه
      if (setIsAuthenticated) {
        setIsAuthenticated(true);
      }
      
      navigate('/splash', { replace: true });
      
    } catch (err) {
      let finalErrorMessage = typeof err === 'string' ? err : err?.message || "حدث خطأ غير متوقع أثناء تسجيل الدخول.";
      setLocalError(finalErrorMessage);
    } finally {
      setLocalLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      {localError && <Alert severity="error">{localError}</Alert>}

      <TextField
        label="المعرف"
        variant="outlined"
        size="small"
        fullWidth
        value={credentials.identifier}
        onChange={(e) => setCredentials({ ...credentials, identifier: e.target.value })}
        disabled={localLoading}
      />
      <TextField
        label="كلمة المرور"
        type="password"
        variant="outlined"
        size="small"
        fullWidth
        value={credentials.password}
        onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
        disabled={localLoading}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        sx={{m:'auto'}}
        disabled={localLoading}
        startIcon={localLoading ? <CircularProgress sx={{ml:'10px'}} size={20} color="inherit" /> : <LoginRoundedIcon sx={{ml:'10px'}}  />}
      >
        {localLoading ? "جاري التحقق وجلب الخطة..." : "دخول"}
      </Button>
    </Box>
  );
};

export default ManualLoginForm;